
document.addEventSelectorListener("click", "[data-layer='button']", function(event, target) {
	let text = (target.innerText || target.textContent).trim();
	let id = target.id.trim();

	const maxTextLength = 40;
	if (maxTextLength < text.length) {
		text = text.substring(0, maxTextLength);
	}

	window.dataLayer.push({
		"event": "click",
		"property1": "button",
		"property2": text,
		"property3": id,
	});
});

document.addEventSelectorListener("click", "[data-layer='consent']", function(event, target) {
	window.dataLayer.push({
		"event": "click",
		"property1": target.getAttribute("data-layer-category").trim()
	});
});

document.addEventSelectorListener("slidetoggleexpanding slidetargetcollapsing clamp:expanding clamp:collapsing", "[data-layer='slide']", function(event, target) {
	let title = target.querySelector("[data-layer-content='title']");
	let text = (title.innerText || title.textContent).trim();

	let category = target.getAttribute("data-layer-category").trim();
	let direction = (event.type == "slidetoggleexpanding" || event.type == "clamp:expanding") ? "open" : "close";

	window.dataLayer.push({
		"event": "click",
		"property1": category,
		"property2": direction,
		"property3": text,
	});
});

document.addEventSelectorListener("submit", "form[data-payment-form]", function(event, form) {
	window.dataLayer.push({
		"event": "form_submit",
		"property1": "before_payment"
	});
});
